<mat-label class="subHeading"
  >LOB<span *ngIf="isRequired" class="star">*</span></mat-label
>
<mat-select multiple formControlName="lob" placeholder="Select">
  <mat-option *ngFor="let lob of lobs" [value]="lob.key">
    {{ lob.val | titlecase}} 
  </mat-option>
</mat-select>
